export default {
    title: "Catalogar",
    noAvailableItems: "No hay productos disponibles para ordenar."
}